module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/orange-grove_d2dd9b.jpg";